var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgRole = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M30.668 28v-2.667a5.333 5.333 0 0 0-4-5.16M22.665 28v-2.667A5.333 5.333 0 0 0 17.332 20H6.665a5.333 5.333 0 0 0-5.333 5.333V28M21.332 4.173a5.333 5.333 0 0 1 0 10.334M12.001 14.667a5.333 5.333 0 1 0 0-10.667 5.333 5.333 0 0 0 0 10.667Z",
  stroke: "#182540",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default SvgRole;